import themeColors from '@/assets/theme/colors'
import textNoSelect from '@/assets/theme/textNoSelect'

const classes = {
  card: {
    ...textNoSelect,
    display: 'flex',
    flexDirection: 'column' as 'column',
    height: '100%',
    background: themeColors.kroemtech.background,
    border: `1px solid ${themeColors.gray.lighter}`,
    borderRadius: '12px',
    padding: '2rem 1.75rem',
    boxSizing: 'border-box' as 'border-box'
  },
  cardFeature: {
    border: `2px solid ${themeColors.bg.start}`
  },
  number: {
    fontWeight: 600,
    lineHeight: 1,
    letterSpacing: '-0.02em',
    color: themeColors.gray[900],
    margin: '0 0 1rem'
  },
  numberNote: {
    fontWeight: 500,
    color: themeColors.gray.mid
  },
  body: {
    lineHeight: 1.6,
    color: themeColors.gray.mid,
    margin: '0 0 1.5rem',
    flex: 1
  },
  source: {
    lineHeight: 1.5,
    color: themeColors.gray[500],
    borderTop: `1px solid ${themeColors.gray.lighter}`,
    paddingTop: '1rem',
    margin: 0
  }
}

export default classes
